import React, { useState, useEffect } from 'react';
import { Box, TextField, Button } from '@mui/material';
import { GroupWithId } from './MetadataInterfaces';

interface GroupFormProps {
  group?: GroupWithId;
  onSave: (group: Omit<GroupWithId, 'id' | 'sections'>) => void;
  onCancel: () => void;
}

const GroupForm: React.FC<GroupFormProps> = ({ group, onSave, onCancel }) => {
  const [name, setName] = useState(group?.name || '');

  useEffect(() => {
    if (group) {
      setName(group.name);
    }
  }, [group]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ name });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <TextField
        fullWidth
        label="Group Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        margin="normal"
        required
      />
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onCancel} sx={{ mr: 1 }}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default GroupForm;
